import { getCookie } from "../../../../utils/cookie";
import apiRequest from "../../../../utils/apiClient";
import { deleteMyCreationUrl } from "../../../constants";

export const deleteCreation = async (
  creationId: number,
  messageStore: any,
): Promise<boolean> => {
  const body = new URLSearchParams({ creation_id: creationId.toString() });

  try {
    const response = await apiRequest(deleteMyCreationUrl, {
      method: "POST",
      mode: "cors",
      body,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "X-CSRFToken": getCookie("csrftoken"),
      },
    });
    if (response.status === 401) {
      messageStore.setMessage("Authentication failed. Please log in again.", "error");
      return false;
    }
    const result = await response.json();
    if (response.ok && result.message) return true;
    messageStore.setMessage(`Error deleting creation: ${result.message || "Unknown error"}`, "error");
    return false;
  } catch (error: any) {
    messageStore.setMessage(`Network error: ${error.message}`, "error");
    return false;
  }
};
